<template>
  <form novalidate @submit.prevent="nextStep" @keyup.prevent="handleOnKeyup">
    <div class="forms-container">
      <div class="verifications">
        <div class="form py-8">
          <div class="card w-full">
            <h2 class="title uppercase font-semibold text-center">
              Identifier
            </h2>

            <div class="auth-steppers">
              <horizontal-stepper
                ref="stepperRef"
                :steps="authSteps"
                :keep-alive="false"
                @before-next-step="beforeNextStep"
                @completed-step="completeStep"
                @active-step="isStepActive"
                class="bg-white shadow-login-form overflow-hidden sm:rounded-lg px-3"
              ></horizontal-stepper>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
require("typeface-poppins");
import HorizontalStepper from "vue-stepper";
import SchoolAuth from "./SchoolAuth";
import OTPAuth from "./OTPAuth";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { dashboard_router_name } from "@/routes/routes";
const SCHOOL_AUTH_NAME = "school-id-verification";
const OTP_AUTH_NAME = "otp-verification";
import { initFcm } from "@/helpers/firebase";

export default {
  components: {
    HorizontalStepper
  },
  data() {
    const allSupportedSteps = [
      {
        icon: "account_box",
        name: SCHOOL_AUTH_NAME,
        title: "Select your School",
        component: SchoolAuth,
        completed: false
      }
    ];

    return {
      authSteps: allSupportedSteps
    };
  },
  computed: {
    // ...mapGetters("schoolAuth", {
    //   storedScId: "ScId",
    // }),
    ...mapGetters("user", {
      storeUserInfo: "info"
    })
  },
  methods: {
    ...mapActions("schoolAuth", ["VerifyScId", "VerifyOTP", "byPassOTP"]),
    ...mapActions("user", ["FetchUserInformation"]),
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.authSteps.forEach(step => {
        if (step.name === payload.name) {
          step.completed = true;
        }
      });
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.authSteps.forEach(step => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            step.completed = false;
          }
        }
      });
    },
    async checkByPassOtp(data, currentStep, next) {
      currentStep.error && this.$set(currentStep, "error", "");
      if (data.otp === "NONE") {
        await this.FetchUserInformation();
        this.byPassOTP();
        this.$router.push({ name: dashboard_router_name });
        initFcm(this.storeUserInfo);
      } else {
        if (!this.authSteps.some(step => step.name === OTP_AUTH_NAME))
          this.authSteps.push({
            icon: "contact_mail",
            name: OTP_AUTH_NAME,
            title: "Verify OTP code",
            component: OTPAuth,
            completed: false
          });
        next();
      }
    },
    async beforeNextStep({ currentStep }, next) {
      try {
        if (currentStep.name === SCHOOL_AUTH_NAME) {
          const res = await this.VerifyScId(currentStep.scId);
          if (res) {
            await this.FetchUserInformation();
            this.byPassOTP();
            this.$router.push({ name: dashboard_router_name });
            initFcm(this.storeUserInfo);
          }
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.message || "Something went wrong!";
        this.$set(currentStep, "error", errMsg);
        this.updateNextBtnStatus();
      }
    },
    nextStep() {
      if (this.$refs.stepperRef.canContinue) {
        this.$refs.stepperRef.nextStep();
      }
    },

    updateNextBtnStatus(active = true) {
      this.$refs.stepperRef.canContinue = active;
      this.$refs.stepperRef.changeNextBtnValue({
        nextBtnValue: active
      });
    },

    handleOnKeyup(event) {
      if (event.keyCode === 13) {
        this.nextStep();
      }
    }
  },
  provide() {
    return {
      nextStep: this.nextStep
    };
  }
};
</script>

<style lang="scss">
.shadow-login-form {
  box-shadow: 0 10px 15px 5px #ebe8e8 !important;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  .verifications {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 75%;
    width: 50%;
    transition: 1s 0.7s ease-in-out;
    display: grid;
    grid-template-columns: 1fr;
    z-index: 5;

    @media (max-width: 870px) {
      width: 100%;
      top: 95%;
      left: 50%;
      transform: translate(-50%, -100%);
      transition: 1s 0.8s ease-in-out;
    }
  }

  .form {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 0rem 5rem;
    transition: all 0.2s 0.7s;
    overflow: hidden;
    grid-column: 1 / 2;
    grid-row: 1 / 2;

    @media (max-width: 570px) {
      padding: 0 1.5rem;
    }

    .auth-steppers {
      .stepper-box {
        // .content {
        //   display: flex;
        //   align-items: center;
        // }

        .top {
          .steps-wrapper {
            .step.activated,
            .step.deactivated {
              .circle {
                i {
                  background-image: linear-gradient(
                    95deg,
                    #04befe 0%,
                    #5995fd 50%,
                    #4481eb 100%
                  );
                  boxshadow: 0 4px 10px 0 rgba(0, 0, 0, 0.25);
                }
              }
            }
            .step.activated + .step.deactivated {
              .circle {
                i {
                  background-image: none !important;
                }
              }
            }
          }
        }

        .bottom {
          .stepper-button {
            font-weight: 500;
          }
          .stepper-button:not(.previous) {
            border-radius: 4px;
            padding-left: 1.5rem;
          }

          .stepper-button.previous {
            border-radius: 4px;
            padding-right: 1.5rem;
            color: #374151;

            transition: 0.15s;

            &:hover {
              color: white;
              background-color: rgba(#374151, 0.1);
              box-shadow: 0 1px 3px rgb(0 0 0 / 12%), 0 1px 2px rgb(0 0 0 / 24%);
            }
          }

          .stepper-button.deactivated {
            pointer-events: none;
          }
        }
      }
    }
  }
}
</style>
